const loadMarkdown = async (
  locale: string,
  markdownImports: Record<string, () => Promise<{ default: string }>>,
): Promise<string | null> => {
  if (!(locale in markdownImports)) return null;

  const importer = markdownImports[locale];

  const markdownModule = await importer();
  return markdownModule.default;
};

export default loadMarkdown;
